import ReportMovementsProducts from './ReportMovementsProducts';

export default ReportMovementsProducts;
